import axios from "axios";
import { setCookie } from "../helpers/cookies";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Request Interceptor
api.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const accessToken = localStorage.getItem("coach_token")
    if (accessToken) {
      config.headers["Authorization"] = accessToken;
    }
    // You can also check if the token needs refreshing here
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    // Any status code within the range of 2xx causes this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    // Any status codes outside the range of 2xx cause this function to trigger
    // Do something with response error

	// Handle 401 Unauthorized response - token expired
	if (error.response && error.response.status === 401 && !originalRequest._retry) {
		originalRequest._retry = true;
		
		try {
			const currentToken = localStorage.getItem("coach_token");
			if (!currentToken) {
				window.location.href = "/login";
				return Promise.reject(error);
			}

			// Call refresh token endpoint
			const refreshResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/refresh-token`, {},
				{
					headers: {
						"Authorization": currentToken,
						"accept": "application/json"
					}
				}
			)

			const newToken = refreshResponse.data.token;
			
			// Update token in localStorage
			localStorage.setItem("coach_token", newToken);
			setCookie("coach_token", newToken, 1);
			
			
			// Update the original request with new token
			originalRequest.headers.Authorization = newToken;
			
			// Retry the original request
			return api(originalRequest);
			
		} catch (refreshError) {
			// If refresh fails, remove token and redirect to login
			localStorage.removeItem("coach_token");
			window.location.href = "/login";
			return Promise.reject(refreshError);
		}
	}

    return Promise.reject(error);
  }
);

export default api;
